(function(){
const FREE_SHIP_CENTS = window.RR_FREE_SHIP_CENTS || 10000;
function money(c){
  if(window.RRShipProgress && window.RRShipProgress.money){
    return window.RRShipProgress.money(c, (window.Shopify && window.Shopify.money_format) || '');
  }
  return '$'+(c/100).toFixed(2);
}
let shipCelebrated = null;
const SHIP_CSS_ID = 'rr-sp-styles';
/* Drawer copy of the shipping progress component. Geometry is kept in step
   with snippets/rr-shipping-progress.liquid on purpose: both style blocks use
   the class name .rr-sp, so on the cart page whichever block wins the cascade
   must produce the same layout.
   The drawer is width:min(440px,92vw) and .rr-drawer-foot adds 26px of padding
   each side, so at a 320px viewport this component is about 241px wide. The
   marks strip is inset 6px each side so the 11px dot at 100% cannot hang past
   the track, and the legend is a positioned box with the same inset so each
   label sits under its own dot and is free to wrap to two lines. */
function injectShipStyles(){
  if(document.getElementById(SHIP_CSS_ID)) return;
  const st = document.createElement('style');
  st.id = SHIP_CSS_ID;
  st.textContent = [
    '.rr-sp{position:relative;margin:0 0 16px;padding:0;max-width:100%;box-sizing:border-box;overflow:hidden;}',
    '.rr-sp__head{display:flex;flex-wrap:wrap;align-items:baseline;justify-content:space-between;gap:4px 10px;margin:0 0 10px;}',
    '.rr-sp__headline{margin:0;flex:1 1 150px;min-width:0;font-size:11.5px;letter-spacing:.04em;line-height:1.4;color:#EAE0D1;overflow-wrap:anywhere;}',
    '.rr-sp__pct{flex:0 0 auto;margin-left:auto;font-size:11px;letter-spacing:.10em;color:#C5A059;white-space:nowrap;}',
    '.rr-sp__track{position:relative;width:100%;max-width:100%;box-sizing:border-box;height:9px;border-radius:999px;background:rgba(255,255,255,.08);box-shadow:inset 0 1px 3px rgba(0,0,0,.6);overflow:visible;}',
    '.rr-sp__fill{position:absolute;inset:0 auto 0 0;width:0;height:100%;border-radius:999px;background:linear-gradient(90deg,#8a5e28 0%,#C5A059 26%,#DFB971 52%,#FFF3D6 72%,#A37F3D 100%);background-size:200% 100%;transition:width .5s cubic-bezier(.22,.9,.3,1);animation:rrspShimmer 3.4s linear infinite;}',
    '.rr-sp__marks{position:absolute;top:0;bottom:0;left:6px;right:6px;pointer-events:none;}',
    '.rr-sp__dot{position:absolute;top:50%;width:11px;height:11px;margin:-5.5px 0 0 -5.5px;border-radius:50%;background:rgba(255,255,255,.10);border:1px solid rgba(197,160,89,.45);box-shadow:inset 0 1px 2px rgba(0,0,0,.5);}',
    '.rr-sp__dot.is-passed{background:linear-gradient(140deg,#DFB971,#A37F3D);border-color:#FFF3D6;box-shadow:0 0 8px rgba(223,185,113,.7);animation:rrspPop .42s cubic-bezier(.3,1.5,.4,1) both;}',
    '.rr-sp__legend{position:relative;display:block;margin:10px 6px 0;min-height:2.8em;font-size:9px;letter-spacing:.04em;line-height:1.25;text-transform:uppercase;color:#8f7a56;}',
    '.rr-sp__legend span{position:absolute;top:0;display:block;width:31%;max-width:31%;text-align:center;white-space:normal;overflow-wrap:anywhere;}',
    '.rr-sp__legend span:nth-child(1){left:34%;transform:translateX(-50%);}',
    '.rr-sp__legend span:nth-child(2){left:67%;transform:translateX(-50%);}',
    '.rr-sp__legend span:nth-child(3){left:100%;transform:translateX(-100%);text-align:right;}',
    '.rr-sp__legend span.is-passed{color:#DFB971;}',
    '.rr-sp.is-close .rr-sp__track{animation:rrspGlow 2.1s ease-in-out infinite;}',
    '.rr-sp.is-close .rr-sp__headline{animation:rrspBob 2.4s ease-in-out infinite;}',
    '.rr-sp__burst{position:absolute;left:0;right:0;bottom:14px;height:0;pointer-events:none;z-index:2;}',
    '.rr-sp__piece{position:absolute;left:50%;top:0;opacity:0;will-change:transform,opacity;animation:rrspBurstFly 1.35s cubic-bezier(.16,.82,.3,1) forwards;}',
    '.rr-sp__piece--dot{width:6px;height:6px;border-radius:50%;}',
    '.rr-sp__piece--ribbon{width:4px;height:11px;border-radius:1px;}',
    '@keyframes rrspShimmer{0%{background-position:0% 50%;}100%{background-position:200% 50%;}}',
    '@keyframes rrspPop{0%{transform:scale(.5);}62%{transform:scale(1.22);}100%{transform:scale(1);}}',
    '@keyframes rrspGlow{0%,100%{box-shadow:inset 0 1px 3px rgba(0,0,0,.6),0 0 0 rgba(223,185,113,0);}50%{box-shadow:inset 0 1px 3px rgba(0,0,0,.6),0 0 14px rgba(223,185,113,.55);}}',
    '@keyframes rrspBob{0%,100%{transform:translateY(0);}50%{transform:translateY(-3px);}}',
    '@keyframes rrspBurstFly{0%{opacity:0;transform:translate3d(0,0,0) rotate(0deg) scale(.55);}10%{opacity:1;}70%{opacity:1;}100%{opacity:0;transform:translate3d(var(--rrsp-dx,0px),var(--rrsp-dy,-90px),0) rotate(var(--rrsp-rot,180deg)) scale(1);}}',
    '@media (prefers-reduced-motion: reduce){.rr-sp__fill{animation:none;transition:none;}.rr-sp__dot.is-passed,.rr-sp.is-close .rr-sp__track,.rr-sp.is-close .rr-sp__headline{animation:none;}.rr-sp__burst{display:none;}}'
  ].join('');
  document.head.appendChild(st);
}
function shipHeadline(remaining, pct){
  if(remaining <= 0) return 'Free shipping unlocked. Nicely done.';
  if(pct > 67) return 'So close. Just '+money(remaining)+' to go';
  if(pct >= 34) return 'Nice start. '+money(remaining)+' more for free shipping';
  return 'Add '+money(remaining)+' more for free shipping';
}
function shipMarkup(total){
  const goal = FREE_SHIP_CENTS > 0 ? FREE_SHIP_CENTS : 10000;
  let pct = (total / goal) * 100;
  if(pct > 100) pct = 100;
  if(pct < 0) pct = 0;
  const remaining = Math.max(0, goal - total);
  const cls = (at) => pct >= at ? ' is-passed' : '';
  return '<div class="rr-sp'+(pct > 67 ? ' is-close' : '')+'" data-rr-ship>'
    + '<div class="rr-sp__head">'
    +   '<p class="rr-sp__headline" aria-live="polite">'+shipHeadline(remaining, pct)+'</p>'
    +   '<span class="rr-sp__pct">'+Math.round(pct)+'%</span>'
    + '</div>'
    + '<div class="rr-sp__track" role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-valuenow="'+Math.round(pct)+'" aria-label="Progress toward free shipping">'
    +   '<div class="rr-sp__fill" style="width:'+pct+'%"></div>'
    +   '<div class="rr-sp__marks">'
    +     '<i class="rr-sp__dot'+cls(34)+'" style="left:34%"></i>'
    +     '<i class="rr-sp__dot'+cls(67)+'" style="left:67%"></i>'
    +     '<i class="rr-sp__dot'+cls(100)+'" style="left:100%"></i>'
    +   '</div>'
    + '</div>'
    + '<div class="rr-sp__legend">'
    +   '<span class="'+(pct >= 34 ? 'is-passed' : '')+'">Good start</span>'
    +   '<span class="'+(pct >= 67 ? 'is-passed' : '')+'">Almost there</span>'
    +   '<span class="'+(pct >= 100 ? 'is-passed' : '')+'">Free shipping</span>'
    + '</div>'
    + '<div class="rr-sp__burst" data-rr-ship-burst aria-hidden="true"></div>'
    + '</div>';
}
function shipConfetti(host){
  if(!host) return;
  if(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  const colors = ['#FFF3D6','#DFB971','#C5A059','#A37F3D','#F2E7CE','#8a5e28'];
  const frag = document.createDocumentFragment();
  for(let i = 0; i < 46; i++){
    const p = document.createElement('i');
    p.className = 'rr-sp__piece ' + ((i % 3 === 0) ? 'rr-sp__piece--ribbon' : 'rr-sp__piece--dot');
    const spread = (i / 45) * 2 - 1;
    p.style.background = colors[i % colors.length];
    p.style.setProperty('--rrsp-dx', Math.round(spread * 150 + (Math.random() * 34 - 17)) + 'px');
    p.style.setProperty('--rrsp-dy', Math.round(-70 - Math.random() * 96) + 'px');
    p.style.setProperty('--rrsp-rot', Math.round((Math.random() * 720) - 360) + 'deg');
    p.style.animationDelay = (i * 11) + 'ms';
    frag.appendChild(p);
  }
  host.appendChild(frag);
  setTimeout(function(){ if(host){ host.innerHTML = ''; } }, 2300);
}
function primeShip(){
  if(shipCelebrated !== null) return;
  const c = document.querySelector('[data-rr-cart-count]');
  if(c && parseInt(c.textContent, 10) === 0){ shipCelebrated = false; }
}
function shipCelebrate(scope, total){
  const goal = FREE_SHIP_CENTS > 0 ? FREE_SHIP_CENTS : 10000;
  const reached = total >= goal;
  if(shipCelebrated === null){ shipCelebrated = reached; return; }
  if(reached && !shipCelebrated){
    shipCelebrated = true;
    shipConfetti(scope.querySelector('[data-rr-ship-burst]'));
  } else if(!reached){
    shipCelebrated = false;
  }
}
function open(){document.body.classList.add('rr-drawer-open');}
function close(){document.body.classList.remove('rr-drawer-open');}
async function refresh(){
  const cart = await (await fetch('/cart.js')).json();
  document.querySelectorAll('[data-rr-cart-count]').forEach(el=>el.textContent=cart.item_count);
  const body = document.querySelector('[data-rr-drawer-body]');
  const foot = document.querySelector('[data-rr-drawer-foot]');
  document.dispatchEvent(new CustomEvent('rr:cart:update', {detail: cart}));
  if(!body) return cart;
  if(cart.item_count===0){
    body.innerHTML = '<p style="font-size:14px;color:#EAE0D1;">Your cart is empty.</p>';
  } else {
    body.innerHTML = cart.items.map(it=>`
      <div class="rr-drawer-line" data-key="${it.key}">
        <img src="${it.image? it.image.replace(/(\.[a-z]+)(\?|$)/,'_128x$1$2'):''}" alt="">
        <div>
          <div style="font-family:'Playfair Display',serif;font-size:15px;color:#F2E7CE;">${it.product_title}</div>
          ${it.variant_title? '<div style="font-size:11px;color:#B08150;">'+it.variant_title+'</div>':''}
          <div class="rr-qty" style="margin-top:6px;">
            <button type="button" data-rr-minus aria-label="Decrease quantity">−</button>
            <span style="font-size:13px;">${it.quantity}</span>
            <button type="button" data-rr-plus aria-label="Increase quantity">+</button>
          </div>
        </div>
        <div style="font-size:13px;color:#D9C49A;">${money(it.final_line_price)}</div>
      </div>`).join('');
  }
  if(foot){
    injectShipStyles();
    foot.innerHTML = shipMarkup(cart.total_price)
      + `<div style="display:flex;justify-content:space-between;align-items:center;margin:14px 0;">
        <span style="font-size:13px;color:#EAE0D1;">Subtotal</span>
        <strong style="font-size:16px;color:#D9C49A;">${money(cart.total_price)}</strong>
      </div>
      <a href="/checkout" class="rr-btn rr-btn--gold" style="display:block;text-align:center;">Checkout</a>
      <a href="/cart" style="display:block;text-align:center;font-size:11px;letter-spacing:.14em;text-transform:uppercase;margin-top:12px;">View Cart</a>`;
    shipCelebrate(foot, cart.total_price);
  }
  return cart;
}
async function changeQty(key, qty){
  await fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:key,quantity:qty})});
  refresh();
}
document.addEventListener('click', function(e){
  const opener = e.target.closest('[data-rr-cart-open]');
  if(opener){e.preventDefault();refresh().then(open);return;}
  if(e.target.closest('[data-rr-drawer-close]') || e.target.classList.contains('rr-drawer-overlay')){close();return;}
  const line = e.target.closest('.rr-drawer-line');
  if(line){
    const qtyEl = line.querySelector('.rr-qty span');
    const qty = parseInt(qtyEl.textContent,10);
    if(e.target.closest('[data-rr-minus]')) changeQty(line.dataset.key, qty-1);
    if(e.target.closest('[data-rr-plus]')) changeQty(line.dataset.key, qty+1);
  }
});
document.addEventListener('keydown', e=>{if(e.key==='Escape')close();});
if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', primeShip); } else { primeShip(); }
// Intercept product form submits -> add via AJAX and open drawer.
// A rejected add (sold out, inventory race, cart limit) must not open the
// drawer: an unchanged cart sliding open reads as success to the customer.
function clearAddError(form){
  const old = form.querySelector('[data-rr-add-error]');
  if(old && old.parentNode) old.parentNode.removeChild(old);
}
function showAddError(form, msg){
  clearAddError(form);
  const p = document.createElement('p');
  p.className = 'rr-err';
  p.setAttribute('data-rr-add-error','');
  p.setAttribute('role','alert');
  p.style.margin = '12px 0 0';
  p.textContent = msg;
  const btn = form.querySelector('[data-rr-add]') || form.querySelector('[type="submit"]');
  const anchor = btn ? (btn.closest('.rr-buyrow') || btn) : null;
  if(anchor && anchor.parentNode){ anchor.parentNode.insertBefore(p, anchor.nextSibling); }
  else { form.appendChild(p); }
  if(p.scrollIntoView) p.scrollIntoView({block:'nearest'});
}
document.addEventListener('submit', async function(e){
  const form = e.target.closest('form[action*="/cart/add"]');
  if(!form) return;
  e.preventDefault();
  clearAddError(form);
  let res, data = null;
  try{
    res = await fetch('/cart/add.js',{method:'POST',headers:{'Accept':'application/json'},body:new FormData(form)});
    try{ data = await res.json(); }catch(parseErr){ data = null; }
  }catch(netErr){
    showAddError(form, 'We could not reach the cart. Check your connection and try again.');
    return;
  }
  if(!res.ok){
    showAddError(form, (data && (data.description || data.message)) || 'Sorry, we could not add that to your cart.');
    return;
  }
  await refresh(); open();
});
})();
